import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { appPaths } from 'consts/paths/paths';
import { AppButton } from 'components/atoms';
import { authTexts } from 'consts/text';
import { ContainerRow, LeftIcon, RightContainer } from './AuthUpperNavBar.styled';

export const AuthUpperNavBar = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const navigateToSignup = useCallback(() => {
        navigate({ pathname: appPaths.auth['sign-up'] });
    }, [navigate]);

    return (
        <ContainerRow>
            <LeftIcon />
            {location.pathname !== appPaths.auth['sign-up'] && (
                <RightContainer>
                    <AppButton
                        type="primary"
                        margin={0}
                        marginRight="marginSmall"
                        onClick={navigateToSignup}
                    >
                        {authTexts.testTheAppButtonLabel}
                    </AppButton>
                </RightContainer>
            )}
        </ContainerRow>
    );
};
